import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Process from '../components/Process';
import Advantages from '../components/Advantages';
import Integrations from '../components/Integrations';
import CTA from '../components/CTA';

const Home = () => {
  return (
    <div>
      <Hero />
      <Services />
      <Process />
      <Advantages />
      <Integrations />
      <CTA />
    </div>
  );
};

export default Home;
